import React, { Component } from 'react'
import moment from 'moment'
import 'utils/locale'
import { DateTimeUtils } from 'utils'

export class Countdown extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      timeRemaining: this.calculateTimeRemaining()
    }
  }

  handleElapse = () => {
    if (this.props.onElapse)
      this.props.onElapse()
  }

  componentDidMount = () => {
    this.interval = setInterval(this.updateTime, 1000)
  }

  componentWillUnmount = () => {
    clearInterval(this.interval)
  }

  updateTime = () => {
    if (this.timeRemaining && !this.elapsed) {
      this.elapsed = true
      this.handleElapse()
    }
    else {
      this.elapsed = false
    }

    this.timeRemaining = this.calculateTimeRemaining()
  }

  calculateTimeRemaining = () => {
    const now = moment(Date.now())
    const until = moment(this.props.until)
    if (now >= until)
      return ''
    const period = moment.duration(Math.max(until.diff(now), 0), 'milliseconds');
    return DateTimeUtils.displayTimeDiff(period)
  }

  format = number => {
    return ("0" + number).slice(-2)
  }

  get timeRemaining() {
    return this.state.timeRemaining
  }
  set timeRemaining(value) {
    if (value !== this.timeRemaining)
      this.setState({timeRemaining: value})
  }

  get typographyProps() {
    const { until, onElapse, ...typographyProps} = this.props
    return typographyProps
  }

  render = () =>
    <span {...this.typographyProps}>{this.timeRemaining}</span>

}